import { jsxs as s, jsx as e } from "react/jsx-runtime";
import { useOfferStore as n } from "../../../../store/index.mjs";
import { hiddenStripePaymentElementTermsOptions as p } from "../../constants/stripe-payment-element-options.mjs";
import { StripeExpressCheckout as m } from "./stripe-express-checkout.mjs";
import { useStripe as a, PaymentElement as l } from "../../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { PaymentMethodEnum as d } from "@systemeio/ui";
function S(t) {
  const r = a(), { availablePaymentMethods: i } = n();
  if (!r) return null;
  const o = i.includes(d.stripe_applepay);
  return /* @__PURE__ */ s("div", { children: [
    o && /* @__PURE__ */ e(m, { ...t }),
    /* @__PURE__ */ e(
      l,
      {
        options: {
          ...p,
          fields: {
            billingDetails: {
              address: "never"
            }
          }
        }
      }
    )
  ] });
}
export {
  S as StripeCardDetails
};
